// arrayUnset

/**
 * @template T
 * @param {T[]} array
 * @param {number} index
 *
 * @return {T[]} array passed to this function by first argument
 */
export function arrayUnset<T>(array: T[], index: number): T[] {
    if (index >= 0) {
        array.splice(index, 1);
    }

    return array;
}

export const arrayDelete = arrayUnset;
export const arrayForget = arrayUnset;

// arrayUnsetImmutable

/**
 * @template T
 * @param {T[]} array
 * @param {number} index
 *
 * @return {T[]} array passed to this function by first argument
 */
export function arrayUnsetImmutable<T>(array: T[], index: number): T[] {
    return arrayUnset(array.slice(), index);
}

export const arrayDeleteImmutable = arrayUnsetImmutable;
export const arrayForgetImmutable = arrayUnsetImmutable;

// arrayUnsetValue

/**
 * @template T
 * @param {T[]} array
 * @param {T} value
 *
 * @return {T[]} array passed to this function by first argument
 */
export function arrayUnsetValue<T>(array: T[], value: T): T[] {
    const index = array.findIndex(v => v === value);

    return arrayUnset(array, index);
}

export const arrayDeleteValue = arrayUnsetValue;
export const arrayForgetValue = arrayUnsetValue;

// arrayUnsetValueImmutable

/**
 * @template T
 * @param {T[]} array
 * @param {T} value
 *
 * @return {T[]} array passed to this function by first argument
 */
export function arrayUnsetValueImmutable<T>(array: T[], value: T): T[] {
    return arrayUnsetValue(array.slice(), value);
}

export const arrayDeleteValueImmutable = arrayUnsetValueImmutable;
export const arrayForgetValueImmutable = arrayUnsetValueImmutable;

export default arrayUnset;
